<template>
  <footer>
    <div class="light">
      <ul>
        <li  v-bind:key="item.title" v-for="item in footerLinkCSV">
          <a v-bind:href="`${ item.url }`" target="_blank">{{ item.title }}</a>
          <img src="../../assets/images/icn-blank.png" alt="Open with a new window."/>
        </li>
        <b-button id="pagetop" @click="scrollToTop" v-bind:class="{ displayNone: showPageBtn === false }"><font-awesome-icon :icon="['fas', 'caret-up']"></font-awesome-icon></b-button>
      </ul>
    </div>
    <div class="dark">
      Copyright © WEST JAPAN RAILWAY COMPANY all rights reserved.<br>
      このサイトに掲載されている情報はJR西日本が提供しております。
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'sp-site-footer',
  created () {
    this.$store.dispatch('externalData/footerLinkCSV')
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  },
  computed: {
    ...mapState('externalData', {
      footerLinkCSV: state => state.footerLinkCSV
    }),
    ...mapState('scroll', {
      showPageBtn: state => state.showPageBtn
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../../css/variables';
footer {
  .light {
    margin-top: 3rem;
    background-color: $footer-light-back;
    padding: 1.29rem 0.94rem 1.29rem 1.25rem;
    ul {
      list-style: none;
      padding: 0;
      margin-bottom: 0;
      li {
        line-height: 2.13rem;
        font-size: 0.875rem;
        font-weight: 600;
        img {
          width: 12px;
          height: 10px;
        }
        a {
          color: $text-color;
        }
      }
    }
  }
  .dark {
    background-color: $footer-dark-back;
    padding: 1.5rem 1.3rem;
    font-size: 0.6rem;
    color: white;
  }
}
#pagetop {
  position: fixed;
  right: 15px;
  bottom: 135px;
  width: 2.125rem;
  background: black;
  border-radius: 0;
  display: block;
  &.displayNone {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpSiteFooter.vue